<template>
  <div class="gameSignUp">
    <HeadBar title="上传完事证明" />
    <div class="gameSignUpInfo">
      <uploadImg></uploadImg>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import uploadImg from "@/components/uploadImg.vue";

  import { Toast } from "vant";

  export default {
    name: "myInfo",
    components: {
      HeadBar,
      uploadImg,
    },
    data() {
      return {};
    },
    computed: {},
    mounted() { },
    methods: {},
  };
</script>
<style scope lang="less">
</style>